import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/manhwa';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category/all?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-white text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">
              虚空韩漫网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(1, 7).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画..."
                className="w-44 pl-3 pr-9 py-2 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-search-line text-sm"></i>
              </button>
            </form>
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 space-y-2">
            <form onSubmit={handleSearch} className="relative mb-4">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画..."
                className="w-full pl-4 pr-10 py-2.5 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <button
                type="submit"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-primary-500 cursor-pointer"
              >
                <i className="ri-search-line"></i>
              </button>
            </form>
            <Link
              to="/"
              className="block px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              首页
            </Link>
            {categories.slice(1).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="block px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}